// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Re90","content":"LoadingAlert_content__1Z_XY"};